<template >
<div class="">


  <alert-box @close="msg.title=''" v-bind:msg="msg" class="mt-2 mb-2"  ></alert-box>
  <waitingModal v-if="waitModal.show == true" @close="closeWaitingModal()"  v-bind:props="waitModal" ></waitingModal>
  
  <div v-if="customerId>0">

  <form v-on:submit.prevent="submit()">
  <div class="form-group mt-4">
    <label for="formGroupExampleInput2">INTESTAZIONE FATTURA</label>
    <input required type="text" id="recipient" class="form-control" v-model="billing.recipient"> 
        
  </div>
  <div class="form-group">
    <label for="formGroupExampleInput3">INDIRIZZO</label>
    <input required type="text" class="form-control" v-model="billing.address" >
        
  </div>
  <div class="form-group">
    <label for="formGroupExampleInput4">CITTA'</label>
    <input required type="text" class="form-control" v-model="billing.city">
        
  </div>

  <div class="form-group">
    <label for="formGroupExampleInput5">PARTITA IVA</label>
    <input required type="text" class="form-control" v-model="billing.vat_number">        
  </div>
  <div class="form-group">
    <label for="formGroupExampleInput6">CODICE FISCALE</label>
    <input required type="text" class="form-control" v-model="billing.tax_id_code">        
  </div>
  

  <div class="form-group">
    <label for="formGroupExampleInput7">CODICE SDI</label>
    <input required type="text" class="form-control" v-model="billing.sdi_code">        
  </div>
  <div class="form-group">
    <label for="formGroupExampleInput8">PEC</label>
    <input required type="text" class="form-control" v-model="billing.pec">        
  </div>
  

      <button v-if="billing.customerId > 0" :disabled="spinner" type="submit" class="btn btn-primary ">
        <i  style="color:#FFCC00" class="fas fa-save mr-3" aria-hidden="true"></i>
         REGISTRA
         <span v-if="spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
      </button>
      
</form>
</div>

</div>
</template>
<script>

import api                        from '@/api'
import alertBox                   from '@/components/common/AlertBox.vue';
import { mapGetters }             from 'vuex';
import waitingModal               from "@/components/common/WaitingModal.vue"  

export default {
  components: {alertBox,waitingModal},
  props :['customerId'] , 
 data () {
    return {
    

      waitModal    : {

        sentinel   : 0,
        show       : false,
        msg1       : 'REGISTRAZIONE IN CORSO ...',
        msg2       : '' 

      },  
       
    billing     : {'customerId':0},    
    spinner     : false,
        
    
    msg : {
        title : '',
        body  : '',
        type  : 0
      }


    }
  },
  directives: 
    {
      focus: {
      
        inserted: function (el) {
          
          el.focus()
          }
           
       
      }
    },

  computed: {
    ...mapGetters(['company','storeId']) 
  },

  
mounted()
{
    this.msg.title = '' 
    
    this.$nextTick(() => {
        this.getData(this.customerId)
    
           //$('#recipient').trigger('focus');
      })
 
},  
created()
{ 
  //console.log('CREATE BILLING',this.customerId)  
 
  this.msg.title = ''  
  this.billing.customerId = this.customerId
    
},
methods :{
closeWaitingModal()
    {
      this.waitModal.show = false
      this.waitModal.sentinel = 0
      
    },
 
initBilling()
{
  

  //this.billing.typeId    = 'CASH'
  
},
async submit()
{

   
    
   if(this.billing.update == 1) 
   {

    this.updateBilling(this.billing)
    return
   }



  this.msg.title = ''  
  this.billing.customerId = this.customerId  
  const sp         = {'sp'   : 'spCreateCustomerBilling'}
  //const data       = {'data' : this.billing }  
  const json       = Object.assign(this.billing, sp)
  
  this.spinner = true
  this.waitModal.show  = true   
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              
              this.waitModal.sentinel = 1 
              this.msg.title = 'REGISTRAZIONE EFFETTUATA.'
              this.msg.body  = ''
              this.msg.type  = 0
              this.billing.update = 1
                                                                  
            }
           else if(res.status==500)
           {               
                this.waitModal.sentinel = 3  
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                this.waitModal.sentinel = 2                 
                
                /*
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                */
                
                 
            } 
        
          }).catch(err => {
              
              this.waitModal.sentinel = 3
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},
async getData(customerId)
{
  this.msg.title = ''
  const sp    = {'sp' : 'spCustomerBilling'}  
  const data = {"customerId":customerId}
  const json  = Object.assign(data, sp)

  this.spinner = true
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              
              //this.coupon = {}
              ///this.initBilling()
              console.log('GET CUSTOMER BILLING',customerId)   
              
              
              //document.getElementById("recipient").focus();
           
                        
              if(res.data.recordsets[0].length > 0)         
              {
                this.billing = res.data.recordsets[0][0]  
                this.billing.update = 1  
                
                
              }
                         
            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });
 
},
async updateBilling(billing)
{
  
  

  this.msg.title = ''
  const sp    = {'sp' : 'spUpdateCustomerBilling'}  
  const json  = Object.assign(billing, sp)

  this.spinner = true
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
              
              //this.coupon = {}
                          
              this.msg.title = 'REGISTRAZIONE EFFETTUATA.'
              this.msg.body  = ''
              this.msg.type  = 0
                 
                         
            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},


}

}

</script>
<style scoped>

label{
    font-weight: bold;
}
</style>
